export const getBrowserLocale = () => {
  const navigator = window.navigator;
  return (navigator.languages && navigator.languages[0]) || navigator.language;
};
